import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import {MessageService} from 'primeng/api'

@Component({
    selector: 'app-configure-role',
    templateUrl: './configure-role.component.html',
    styleUrls: ['./configure-role.component.css'],
    providers: [MessageService],
    standalone: false
})
export class ConfigureRoleComponent implements OnInit {

  // Dropdwon
  option1
  
  constructor(private modalService: BsModalService, private messageService: MessageService, private router: Router) {
    this.option1 = [
      { label: 'Select', value: null },
      { label: 'Option 1', value: { id: 1, name: 'Option1', code: 'O1' } },
      { label: 'Option 2', value: { id: 2, name: 'Option2', code: 'O4' } },
      { label: 'Option 3', value: { id: 3, name: 'Option3', code: 'O3' } },
      { label: 'Option 4', value: { id: 4, name: 'Option4', code: 'O4' } },
      { label: 'Option 5', value: { id: 5, name: 'Option5', code: 'O5' } }
    ];
   }

  ngOnInit(): void {
  }

// Success Alert Start
  showSuccess() {
    this.messageService.add({severity:'success',});
    setTimeout(() => {
      this.router.navigate(['/configureRole']);
    }, 1000);
  }
// Success Alert End
/* MODAL */
  modalRef: BsModalRef;
// Alert 
  alertIcon =  "assets/images/alert-01.svg";
    alert(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template,
    Object.assign({}, { class: 'alertM' })
    );
  }

}
